import { escapeHtml } from '../utils/security';

/**
 * Section header per Maeland Code Craft design:
 * a short sunset dash + mono uppercase kicker, followed by the section h2.
 */
export function sectionHeader(kicker: string | undefined, heading: string): string {
    return `
        <div class="flex items-center gap-3 mb-3.5">
            <span class="w-6 h-0.5 bg-sunset-dark block" aria-hidden="true"></span>
            <span class="font-mono text-[13px] font-medium tracking-[2px] uppercase text-n400">${escapeHtml(kicker)}</span>
        </div>
        <h2 class="text-[32px] leading-10 font-bold tracking-[-0.5px] text-graphite mb-10">${escapeHtml(heading)}</h2>
    `;
}
